import { useMemo, useState } from "react";
import {
  IconLanguage,
  IconLogout,
  IconMenu2,
  IconMap2,
  IconContract,
  IconHomeEdit,
  IconMenu,
  IconReceipt,
  IconTicket,
  IconUsers,
} from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@context/AuthContext";

function CmsLayout({ activeModule, title, children }) {
  const logo = require("@assets/img/brand/logo.png");

  const { authorization, user, logout } = useAuth();
  const navigate = useNavigate();
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(true);
  const [isSidebarAutoExpanded, setIsSidebarAutoExpanded] = useState(false);
  const primaryRole = String(
    authorization?.primaryRole || user?.role || "",
  )
    .toLowerCase()
    .trim();
  const isAdminOnly = primaryRole === "admin";
  const menuItems = useMemo(
    () => {
      const items = [
        {
          key: "tours",
          label: "Tours Manager",
          icon: IconMap2,
          path: "/tours",
        },
        {
          //contenido de editar el home que aparece en el json home
          key: "home-content",
          label: "Home content",
          icon: IconHomeEdit,
          path: "/home-content",
        },
        {
          key: "on-boarding",
          label: "On Boarding",
          icon: IconContract,
          path: "/on-boarding",
        },
        {
          key: "languages",
          label: "Languages",
          icon: IconLanguage,
          path: "/languages",
        },
        {
          key: "users",
          label: "Users",
          icon: IconUsers,
          path: "/users",
        },
        {
          key: "promo-code-batches",
          label: "Promo Code Batches",
          icon: IconTicket,
          path: "/promo-code-batches",
        },
        {
          key: "purchases",
          label: "Purchases",
          icon: IconReceipt,
          path: "/purchases",
        },
      ];
      if (isAdminOnly) {
        return items.filter((item) => item.key === "tours");
      }
      return items;
    },
    [isAdminOnly],
  );
  return (
    <main
      className={`cms-shell ${isSidebarCollapsed ? "aside-collapsed" : ""}`}
    >
      <aside
        className={`cms-aside ${isSidebarCollapsed ? "collapsed" : ""}`}
        onMouseEnter={() => {
          if (!isSidebarCollapsed) return;
          setIsSidebarAutoExpanded(true);
          setIsSidebarCollapsed(false);
        }}
        onMouseLeave={() => {
          if (!isSidebarAutoExpanded) return;
          setIsSidebarAutoExpanded(false);
          setIsSidebarCollapsed(true);
        }}
      >
        <div className="cms-aside-top">
          <button
            className="icon-button"
            type="button"
            onClick={() => {
              setIsSidebarAutoExpanded(false);
              setIsSidebarCollapsed((previous) => !previous);
            }}
            aria-label={isSidebarCollapsed ? "Expandir menu" : "Contraer menu"}
          >
            {isSidebarCollapsed ? (
              <IconMenu2 size={20} />
            ) : (
              <IconMenu size={20} />
            )}
          </button>
          <div className="cms-brand">
            <img src={logo} alt="Logo" className="logo" />
            <span className="cms-brand-text">
              {isSidebarCollapsed ? "C" : "CMS"}
            </span>
          </div>
        </div>

        <nav className="cms-nav">
          {menuItems.map((item) => {
            const MenuIcon = item.icon;
            return (
              <button
                key={item.key}
                className={`cms-nav-item ${activeModule === item.key ? "active" : ""}`}
                type="button"
                onClick={() => {
                  const exitGuard = window.__cmsRouteTypesExitGuard;
                  if (exitGuard) {
                    exitGuard(() => navigate(item.path));
                    return;
                  }
                  navigate(item.path);
                }}
              >
                <MenuIcon size={20} />
                <span>{item.label}</span>
              </button>
            );
          })}
        </nav>

        <div className="cms-aside-bottom">
          <button
            className="cms-nav-item danger"
            type="button"
            onClick={() => {
              const exitGuard = window.__cmsRouteTypesExitGuard;
              if (exitGuard) {
                exitGuard(logout);
                return;
              }
              logout();
            }}
          >
            <IconLogout size={20} />
            <span>Log out</span>
          </button>
        </div>
      </aside>

      <section className="cms-main">
        {/* <header className="cms-main-header">
          <div>
            <p className="env-chip">Environment: {env.name}</p>
            <h1>{title}</h1>
          </div>
          <div className="cms-main-actions">
            <button className="icon-button" type="button" aria-label="Buscar">
              <IconSearch size={19} />
            </button>
            <button
              className="icon-button"
              type="button"
              aria-label="Notificaciones"
            >
              <IconBell size={19} />
            </button>
          </div>
        </header> */}
        <div className="cms-grid">{children}</div>
      </section>
    </main>
  );
}

export default CmsLayout;
